import { DOMAIN } from './data/const';
import Plausible from 'plausible-tracker';

const plausible = Plausible({
  domain: DOMAIN,
  hashMode: true,
});

export default plausible;
